import { i18n } from '@/locales';
import { fieldsMapping } from './useFormFields';
function isValidString(value) {
    // eslint-disable-next-line no-useless-escape
    const regExPattern = /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\d]*/g;
    const match = value.trim().match(regExPattern);
    if ((match === null || match === void 0 ? void 0 : match.length) && match[0].length)
        return false;
    return true;
}
const validationRules = {
    title: {
        required: false,
        validator(rule, value) {
            if (!value.trim()) {
                return new Error(i18n.global.t('generateContentModal.contentTitleEmptyError'));
            }
            else if (!isValidString(value)) {
                return new Error(i18n.global.t('generateContentModal.contentTitleNumberError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    description: {
        required: false,
        validator(rule, value) {
            if (!value.trim()) {
                return new Error(i18n.global.t('generateContentModal.descriptionEmptyError'));
            }
            else if (!isValidString(value)) {
                return new Error(i18n.global.t('generateContentModal.descriptionInvalidError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    keywords: {
        required: false,
        validator(rule, value) {
            if (!value.length) {
                return new Error(i18n.global.t('generateContentModal.addKeywordsEmptyError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    tone: {
        required: false,
        validator(rule, value) {
            if (!value) {
                return new Error(i18n.global.t('generateContentModal.writingToneEmptyError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    numberOfVariations: {
        required: false,
        validator(rule, value) {
            if (!value) {
                return new Error(i18n.global.t('generateContentModal.numberOfVariationsEmptyError'));
            }
            else if (value < 0 || value > 5) {
                return new Error(i18n.global.t('generateContentModal.numberOfVariationsInvalidError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    subType: {
        required: false,
        validator(rule, value) {
            if (!value) {
                return new Error(i18n.global.t('generateContentModal.typeEmptyError'));
            }
            return true;
        },
        trigger: 'blur',
    },
    emailContext: {
        required: false,
        validator(rule, value) {
            if (!value) {
                return new Error(i18n.global.t('generateContentModal.contextEmptyError'));
            }
            return true;
        },
        trigger: 'blur',
    },
};
export const getFormRules = (productType) => {
    if (fieldsMapping[productType]) {
        const required = fieldsMapping[productType].required;
        const rules = validationRules;
        for (const field of required) {
            if (rules[field]) {
                rules[field].required = true;
            }
            else {
                rules[field].validator = () => true;
            }
        }
        return rules;
    }
    return [];
};
